import { UserDataLayerAdapter } from "../shared/UserDataLayerAdapter";
import { User } from "../gtm/User";
import { singleton } from "tsyringe";

@singleton()
export class ToutvUserDataLayerAdapter extends UserDataLayerAdapter {
  constructor(user: User) {
    super(user);
  }

  override get rcId(): string | undefined {
    // Tou.tv's frontend set the RCID to "anonyme" when the user is anonymous
    if (this.user.rcid === "anonyme") {
      return undefined;
    }
    return this.user.rcid;
  }
}
